<script>
    import Navbar from './Components/bootstrap/Navbar.svelte';
    import title from './constantes.js'
</script>

<footer class="opacity-95 bg-azul-consulta border-verde-consulta p-4 text-white">
    <div class="w-75 mx-auto row mx-0">
        <div class="col-12 col-lg-6">
            <img src="./images/logo-2.png" alt="Logo de {title}" title="{title}" class="float-start mr-2" height="40" />
            <p class="pl-2"> © {title}</p>
        </div>
        <div class="col-lg-6 d-none d-lg-flex"><Navbar /></div>
    </div>
</footer>


<style>
    .border-verde-consulta{
        border-top: 6px solid #87af20;
    }
    .opacity-95{
        opacity: 95%;
    }
</style>


